import BdcCreditNoteList from "../components/Bdc/CreditNote";

const BdcCreditNotesPage = () => <BdcCreditNoteList />;

export default BdcCreditNotesPage;
